import React, { useEffect, useRef } from 'react';
import styles from './ScriptModule.module.scss';
import { UI_Heading } from 'ui/components/1-atoms/Heading/Heading';
import { UI_Container } from 'ui/components/4-habitats/Container/Container';

export interface UI_ScriptModuleProps {
	script?: string;
	heading?: string;
	nonce?: string;
}

export const UI_ScriptModule = ({ script, heading, nonce }: UI_ScriptModuleProps) => {
	const scriptRef = useRef<HTMLDivElement | null>(null);

	const scriptBlock = `${script}`;
	useEffect(() => {
		if (nonce || nonce === undefined) {
			const fragment = document.createRange().createContextualFragment(scriptBlock);
			fragment.querySelectorAll('script').forEach((scriptElement) => {
				scriptElement.setAttribute('nonce', nonce);
			});
			scriptRef?.current?.append(fragment);
		}
	}, [nonce, scriptBlock, scriptRef]);
	return (
		<UI_Container width="Standard">
			{heading && (
				<UI_Heading headingLevel="h2" style="sm" className={styles.ScriptModule_heading}>
					{heading}
				</UI_Heading>
			)}
			<div ref={scriptRef}></div>
		</UI_Container>
	);
};
